import { z } from 'zod';

export const EmailSchema = z.object({ email: z.email() });

export const OtpSchema = z.object({ token: z.string().min(6).max(6) });
